var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconRoundText',[_c('CapSVG',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v(" Cursos concluídos "),_c('strong',[_vm._v(_vm._s(_vm.user.courses_completed))]),_vm._v(" / "+_vm._s(_vm.user.courses_attended)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }